"use strict";

exports.__esModule = true;
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _styles = require("./styles");

var _jsxRuntime = require("react/jsx-runtime");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

const DocumentDownloadIcon = ({
  title,
  ...otherProps
}) => /*#__PURE__*/(0, _jsxRuntime.jsxs)("svg", { ...otherProps,
  width: "25",
  height: "40",
  viewBox: "0 0 25 40",
  xmlns: "http://www.w3.org/2000/svg",
  children: [title && /*#__PURE__*/(0, _jsxRuntime.jsx)("title", {
    children: title
  }), /*#__PURE__*/(0, _jsxRuntime.jsx)("g", {
    stroke: "none",
    strokeWidth: "1",
    fill: "none",
    fillRule: "evenodd",
    children: /*#__PURE__*/(0, _jsxRuntime.jsx)("g", {
      transform: "translate(-157.000000, -321.000000)",
      children: /*#__PURE__*/(0, _jsxRuntime.jsx)("g", {
        transform: "translate(157.354651, 320.625012)",
        children: /*#__PURE__*/(0, _jsxRuntime.jsx)("g", {
          transform: "translate(0.000000, 0.286809)",
          children: /*#__PURE__*/(0, _jsxRuntime.jsxs)("g", {
            transform: "translate(0.000381, 0.666679)",
            children: [/*#__PURE__*/(0, _jsxRuntime.jsx)("path", {
              d: "M22.628186,6.92779167e-14 L1.98516279,6.92779167e-14 C0.997348837,6.92779167e-14 0.195465116,0.802837209 0.195465116,1.78969767 L0.195465116,27.7674884 C0.195465116,28.2413721 0.57972093,28.6256279 1.05360465,28.6256279 C1.52748837,28.6256279 1.91174419,28.2413721 1.91174419,27.7674884 L1.91174419,1.78969767 C1.91174419,1.75632558 1.95083721,1.71723256 1.98516279,1.71723256 L22.628186,1.71723256 C22.6606047,1.71723256 22.7006512,1.75060465 22.7006512,1.78969767 L22.7006512,29.6277442 C22.7006512,29.6658837 22.6663256,29.7002093 22.628186,29.7002093 L17.997093,29.7002093 C17.5232093,29.7002093 17.138,30.0854186 17.138,30.5593023 C17.138,31.033186 17.5232093,31.4174419 17.997093,31.4174419 L23.0153023,31.4174419 C23.3013488,31.4174419 23.5425814,31.2686977 23.698,31.0532093 C24.1327907,30.7271163 24.4178837,30.213186 24.4178837,29.6277442 L24.4178837,1.78969767 C24.4178837,0.802837209 23.6150465,6.92779167e-14 22.628186,6.92779167e-14",
              fill: "#FFFFFF",
              className: "svg-fill-secondary"
            }), /*#__PURE__*/(0, _jsxRuntime.jsx)("path", {
              d: "M5.21777442,13.0387628 L19.3942395,13.0387628 C19.8681233,13.0387628 20.2533326,12.654507 20.2533326,12.1806233 C20.2533326,11.7067395 19.8681233,11.3215302 19.3942395,11.3215302 L5.21777442,11.3215302 C4.7438907,11.3215302 4.35963488,11.7067395 4.35963488,12.1806233 C4.35963488,12.654507 4.7438907,13.0387628 5.21777442,13.0387628",
              fill: "#FFFFFF",
              className: "svg-fill-secondary"
            }), /*#__PURE__*/(0, _jsxRuntime.jsx)("path", {
              d: "M5.21777442,8.8105186 L19.3942395,8.8105186 C19.8681233,8.8105186 20.2533326,8.42626279 20.2533326,7.95237907 C20.2533326,7.47849535 19.8681233,7.09328605 19.3942395,7.09328605 L5.21777442,7.09328605 C4.7438907,7.09328605 4.35963488,7.47849535 4.35963488,7.95237907 C4.35963488,8.42626279 4.7438907,8.8105186 5.21777442,8.8105186",
              fill: "#FFFFFF",
              className: "svg-fill-secondary"
            }), /*#__PURE__*/(0, _jsxRuntime.jsx)("path", {
              d: "M20.2528558,16.4095349 C20.2528558,15.9356512 19.8686,15.5513953 19.3947163,15.5513953 L5.21729767,15.5513953 C4.74341395,15.5513953 4.35915814,15.9356512 4.35915814,16.4095349 C4.35915814,16.8834186 4.74341395,17.2676744 5.21729767,17.2676744 L19.3947163,17.2676744 C19.8686,17.2676744 20.2528558,16.8834186 20.2528558,16.4095349",
              fill: "#FFFFFF",
              className: "svg-fill-secondary"
            }), /*#__PURE__*/(0, _jsxRuntime.jsx)("path", {
              d: "M20.2528558,20.6387326 C20.2528558,20.1648488 19.8686,19.780593 19.3947163,19.780593 L12.3055302,19.780593 C11.8316465,19.780593 11.4473907,20.1648488 11.4473907,20.6387326 C11.4473907,21.1126163 11.8316465,21.4968721 12.3055302,21.4968721 L19.3947163,21.4968721 C19.8686,21.4968721 20.2528558,21.1126163 20.2528558,20.6387326",
              fill: "#FFFFFF",
              className: "svg-fill-secondary"
            }), /*#__PURE__*/(0, _jsxRuntime.jsx)("path", {
              d: "M12.0104256,30.0702581 C11.6767047,29.7327233 11.1351233,29.7279558 10.7966349,30.0588163 L7.87323953,32.9297698 L7.87323953,20.6383512 C7.87323953,20.1644674 7.48898372,19.7802116 7.0151,19.7802116 C6.54121628,19.7802116 6.15600698,20.1644674 6.15600698,20.6383512 L6.15600698,32.955514 L3.24500698,29.9901651 C2.91128605,29.6535837 2.37065814,29.6478628 2.03026279,29.9787233 C1.69272791,30.3114907 1.68796047,30.8549791 2.01882093,31.1934674 L6.36196047,35.6157465 C6.53072791,35.7864209 6.75193721,35.8731884 6.97505349,35.8731884 C7.19149535,35.8731884 7.4088907,35.7911884 7.57670465,35.6271884 L11.9989837,31.2840488 C12.3374721,30.9522349 12.3422395,30.407793 12.0104256,30.0702581",
              fill: "#4CAA50",
              className: "svg-fill-primary"
            }), /*#__PURE__*/(0, _jsxRuntime.jsx)("path", {
              d: "M13.1724419,39.3798326 L0.858139535,39.3798326 C0.384255814,39.3798326 1.52766688e-13,38.9955767 1.52766688e-13,38.521693 C1.52766688e-13,38.0478093 0.384255814,37.6626 0.858139535,37.6626 L13.1724419,37.6626 C13.6463256,37.6626 14.0305814,38.0478093 14.0305814,38.521693 C14.0305814,38.9955767 13.6463256,39.3798326 13.1724419,39.3798326",
              fill: "#4CAA50",
              className: "svg-fill-primary"
            }), /*#__PURE__*/(0, _jsxRuntime.jsx)("path", {
              d: "M14.1045721,30.5917209 C14.1045721,30.1092558 14.4955023,29.7192791 14.9779674,29.7192791 C15.4594791,29.7192791 15.8504093,30.1092558 15.8504093,30.5917209 C15.8504093,31.074186 15.4594791,31.4641628 14.9779674,31.4641628 C14.4955023,31.4641628 14.1045721,31.074186 14.1045721,30.5917209",
              fill: "#FFFFFF",
              className: "svg-fill-secondary"
            })]
          })
        })
      })
    })
  })]
});

DocumentDownloadIcon.defaultProps = {
  title: undefined
};

var _default = (0, _styles.colourIcon)(DocumentDownloadIcon);

exports.default = _default;